import { createContext, useContext, useState } from "react";
import type { Space } from "@circle-react/types";
import type { Bookmark } from "../helpers/bookmark_helper";

export interface SortableBookmarkContextProps {
  bookmark: Bookmark;
  isFolderDropdownOpen: boolean;
  setIsFolderDropdownOpen: (isOpen: boolean) => void;
  space: Space;
}

const SortableBookmarkContext =
  createContext<SortableBookmarkContextProps | null>(null);

SortableBookmarkContext.displayName = "SortableBookmarkContext";

export const useSortableBookmarkContext = () => {
  const context = useContext(SortableBookmarkContext);

  if (!context) {
    throw new Error(
      "useSortableBookmarkContext must be used within a SortableBookmark",
    );
  }

  return context;
};

SortableBookmarkContext.displayName = "SortableBookmarkContext";

export interface SortableBookmarkProps {
  bookmark: Bookmark;
  children: React.ReactNode;
  space: Space;
}

export const SortableBookmark = ({
  bookmark,
  space,
  children,
}: SortableBookmarkProps) => {
  const [isFolderDropdownOpen, setIsFolderDropdownOpen] = useState(false);

  return (
    <SortableBookmarkContext.Provider
      value={{
        bookmark,
        space,
        isFolderDropdownOpen,
        setIsFolderDropdownOpen,
      }}
    >
      {children}
    </SortableBookmarkContext.Provider>
  );
};
